import { TherapeuticDomainDto } from "@beyou/app/core/dto/therapeutic-domains/therapeutic-domain.dto";
import { TherapeuticDomainCreateDto } from "@beyou/app/core/dto/therapeutic-domains/therapeutic-domain-create.dto";
import { TherapeuticDomainUpdateDto } from "@beyou/app/core/dto/therapeutic-domains/therapeutic-domain-update.dto";
import { TherapeuticDomain, TherapeuticDomainBase } from "../models/therapeutic-domain.model";
import { ImageAssetMapper } from "./media/cover.mapper";

export class TherapeuticDomainMapper {
  public static toModel(dto: TherapeuticDomainDto): TherapeuticDomain {
    let level = !!dto.level ? dto.level : 1;

    return {
      id: dto.id,
      code: dto.code,
      name: dto.name,
      position: dto.position,
      level: level,
      parentId: dto.parent_id,
      cover: dto.cover? ImageAssetMapper.toModel(dto.cover) : null,
    }
  }

  public static toCreateDto(model: TherapeuticDomainBase): TherapeuticDomainCreateDto {
    return {
      code: model.code,
      name: model.name,
      position: model.position,
      parent_id: model.parentId ?? 0,
      cover: model.cover ? ImageAssetMapper.toDto(model.cover) : undefined,
    }
  }

  public static toUpdateDto(model: TherapeuticDomain): TherapeuticDomainUpdateDto {
    let parentId = model.parentId;
    if (parentId === null) {
      parentId = 0;
    }
    
    return {
      position: model.position,
      parent_id: parentId,
      cover: model.cover ? ImageAssetMapper.toDto(model.cover) : undefined,
    }
  }
}